import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import { t } from '../../localization.js';
import Label from '../Label/Label.js';
import Spinner from '../Spinner/Spinner.js';
import styles from './Textarea.module.scss.js';

var Textarea = (function (_super) {
    __extends(Textarea, _super);
    function Textarea(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event) {
            var description = event.target.value;
            if (_this.props.maxLength && description.length > _this.props.maxLength) {
                description = description.slice(0, _this.props.maxLength);
            }
            _this.props.onChange(description);
            web2clientSounds.playInputSound();
        };
        return _this;
    }
    Textarea.prototype.componentDidMount = function () {
        if (this.props.isFocusOn) {
            this._textarea.focus();
        }
    };
    Textarea.prototype.render = function () {
        var _a;
        var _this = this;
        var _b;
        var classNameTextarea = classNames(styles.textarea, (_a = {},
            _a[styles.isErrored] = this.props.error,
            _a), (_b = this.props) === null || _b === void 0 ? void 0 : _b.className);
        var label = this.props.label ? React.createElement(Label, null, this.props.label) : null;
        var validator = this.props.isValidating ? (React.createElement("div", { className: styles.validator },
            React.createElement(Spinner, null),
            "\u00A0",
            t('Проверка:валидация'))) : null;
        var error = this.props.error ? React.createElement("div", { className: styles.error }, this.props.error) : null;
        var counter = this.props.isCounted ? (React.createElement("div", { className: styles.counter },
            React.createElement("span", { className: styles.counterCurrent }, this.props.value.length),
            " / ",
            this.props.maxLength)) : null;
        return (React.createElement("div", null,
            label,
            React.createElement("div", { className: styles.container },
                React.createElement("textarea", { className: classNameTextarea, style: { width: this.props.width, height: this.props.height }, value: this.props.value, disabled: this.props.isDisabled, onChange: this.onChange, ref: function (ref) {
                        if (ref !== null) {
                            _this._textarea = ref;
                        }
                    }, spellCheck: false }),
                validator,
                error,
                counter)));
    };
    return Textarea;
}(React.PureComponent));

export { Textarea as default };
//# sourceMappingURL=Textarea.js.map
